import React, { Component } from "react";
import "../../css/FilterBar.css";
import { connect } from "react-redux";
import { chosenFilter, sortByFitler } from "../../models";
import { Translation } from "react-i18next";
import { ROOT } from "../../constants";

let $ = window.$;

export class FilterBar extends Component {
  state = {
    filterActive: null,
    showSorting: false
  };

  showFilterContent = index => {
    this.setState({
      filterActive: index
    });
  };

  hideFilterContent = () => {
    this.setState({
      filterActive: null
    });
  };

  chooseFilter = item => {
    // 新增篩選條件到陣列中
    const { addFilter, keywords, activeSortBy } = this.props;
    const changeUrl = true;
    addFilter(item, keywords, activeSortBy, changeUrl);
  };

  clearAllFilter = () => {
    // 清除所有篩選條件
    const { keywords, activeSortBy } = this.props;
    const changeUrl = true;
    this.props.clearAllFilter(keywords, activeSortBy, changeUrl);
  };

  deleteFilter = item => {
    // 移除自身篩選條件
    const { removeFilter, keywords, activeSortBy } = this.props;
    const changeUrl = true;
    removeFilter(item, keywords, activeSortBy, changeUrl);
  };

  showSortingContent = () => {
    this.setState({
      showSorting: true
    });
  };

  hidenSortingContent = () => {
    this.setState({
      showSorting: false
    });
  };

  chooseSorting = item => {
    const { keywords, chosenFilterList } = this.props;
    const changeUrl = true;
    this.props.updateSortBy(item, keywords, chosenFilterList, changeUrl);
  };

  mountingPadding = index => {
    // 計算padding位置
    const itemElement = $(`#filter-item-${index}`).offset();
    const parentElement = $("#filterbar-content").offset();
    if (itemElement && parentElement) {
      const number = itemElement.left - parentElement.left;
      return `${number}px`;
    } else {
      return "0px";
    }
  };

  hadSelected = item => {
    // 判斷此條件是否已被選取
    const found = this.props.chosenFilterList.findIndex(
      data => data.code === item.code
    );
    const selected = found === -1 ? false : true;
    return selected;
  };

  render() {
    const {
      chosenFilterList,
      productRefinements,
      sortByLists,
      activeSortBy,
      lang
    } = this.props;
    return (
      <div>
        <div className="filter-chosen-wrap">
          {chosenFilterList.length > 0 ? (
            <button
              className="cancel-all-filters"
              onClick={this.clearAllFilter}
            >
              <Translation>{t => <>{t("searchPage.applyAll")}</>}</Translation>
            </button>
          ) : null}
          {chosenFilterList.map((item, index) => (
            <span className="choosen-filter-option" key={index}>
              <button
                className="choosen-filter-close-btn"
                onClick={this.deleteFilter.bind(this, item)}
              ></button>
              <span className="choosen-filter-name">{item.name}</span>
            </span>
          ))}
        </div>
        <div className="filterbar-content" id="filterbar-content">
          {productRefinements && (
            <div className="filter-left">
              <Translation>{t => <>{t("searchPage.filterBy")}</>}</Translation>
              ：
              {productRefinements.refinements.map((data, index) => (
                <React.Fragment key={index}>
                  {/* 若categoryCode為CATEGORY則不顯示，其餘皆顯示 */}
                  {data.categoryCode === "CATEGORY" ? null : (
                    <>
                      <div
                        className="filter-item"
                        onMouseEnter={this.showFilterContent.bind(this, index)}
                        onMouseLeave={this.hideFilterContent}
                      >
                        <span
                          className="filter-item-name"
                          id={`filter-item-${index}`}
                        >
                          {data.categoryName}
                        </span>
                        <span className="filter-arrow-down"></span>
                      </div>
                      <div
                        className={`filter-subitem-content ${
                          this.state.filterActive === index
                            ? "filter-subitem-content-opened"
                            : ""
                        }`}
                        onMouseEnter={this.showFilterContent.bind(this, index)}
                        onMouseLeave={this.hideFilterContent}
                      >
                        <div className="filter-subitem-warp">
                          <ul
                            className="filter-option-ul"
                            style={{ paddingLeft: this.mountingPadding(index) }}
                          >
                            {data.criteria.map((item, jndex) => (
                              <li
                                key={jndex}
                                className="filter-option"
                                onClick={
                                  this.hadSelected(item)
                                    ? null
                                    : this.chooseFilter.bind(this, item)
                                }
                                style={{
                                  fontWeight: this.hadSelected(item)
                                    ? "bold"
                                    : "normal"
                                }}
                              >
                                {item.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          <div className="filter-right">
            <Translation>{t => <>{t("searchPage.sortBy")}</>}</Translation>：
            <div
              className="filter-item"
              onMouseEnter={this.showSortingContent}
              onMouseLeave={this.hidenSortingContent}
            >
              <span className="filter-item-name">
                {lang === "en" ? activeSortBy.name_en : activeSortBy.name}
              </span>
              <span className="filter-arrow-down"></span>
            </div>
            <div
              className={`sorting-wrap ${
                this.state.showSorting ? "sorting-wrap-opened" : ""
              }`}
              onMouseEnter={this.showSortingContent}
              onMouseLeave={this.hidenSortingContent}
            >
              <div className="sorting-option-content">
                {sortByLists.map((item, index) => (
                  <div
                    className="sorting-option"
                    key={index}
                    onClick={this.chooseSorting.bind(this, item)}
                    style={{
                      fontWeight: activeSortBy.name === item.name ? "bold" : ""
                    }}
                  >
                    {lang === "en" ? item.name_en : item.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterBar.defaultProps = {
  keywords: "",
  lang: "en"
};

const mapStateToProps = state => {
  return {
    chosenFilterList: state.chosenFilter.chosenFilterList,
    productRefinements: state.searchKeywords.productRefinements,
    activeSortBy: state.sortByFilter.activeSortBy,
    sortByLists: state.sortByFilter.sortByLists,
    urlWithFilter: state.chosenFilter.urlWithFilter
  };
};

const mapDispatchToProps = () => {
  return {
    addFilter: (data, keywords, activeSortBy, changeUrl) =>
      chosenFilter.actions.addFilter(data, keywords, activeSortBy, changeUrl),
    removeFilter: (data, keywords, activeSortBy, changeUrl) =>
      chosenFilter.actions.removeFilter(
        data,
        keywords,
        activeSortBy,
        changeUrl
      ),
    clearAllFilter: (keywords, activeSortBy, changeUrl) =>
      chosenFilter.actions.clearAllFilter(keywords, activeSortBy, changeUrl),
    updateSortBy: (data, keywords, chosenFilterList, changeUrl) =>
      sortByFitler.actions.updateSortBy(
        data,
        keywords,
        chosenFilterList,
        changeUrl
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);
